import React, { Component } from 'react';
import ReactEcharts from 'react-echarts-component';
import { DatePicker } from 'react-md';
import StackUpService from '../../services/StackUpService';
import moment from 'moment';

export default class StackupBottomBar extends Component {

    constructor(props) {
        super(props);

        window.stackBottomBar = this;

        this.defaultProps = {}

        this.stackService = new StackUpService();

        this.state = {
            periodOpen: false,
            tagMenuOpen: false,
            selectedTagCategory: Object.keys(this.props.screenContext.tagList)[0]
        }

        this.tempTagList = [];
        this.tempTagListOld = [];

        this.tempGroupList = [];
        this.tempGroupListOld = [];

        this.togglePeriodOpen = this.togglePeriodOpen.bind(this);
        this.selectPeriod = this.selectPeriod.bind(this);
        this.numberWithCommas = this.numberWithCommas.bind(this);
        this.getPeriodChart = this.getPeriodChart.bind(this);

        this.expandTagMenu = this.expandTagMenu.bind(this);
        this.closeTagMenu = this.closeTagMenu.bind(this);
        this.clearTagMenu = this.clearTagMenu.bind(this);
        this.saveTagMenu = this.saveTagMenu.bind(this);
        this.toggleTempTag = this.toggleTempTag.bind(this);
        this.toggleTempGroup = this.toggleTempGroup.bind(this);

        this.setTagCategory = this.setTagCategory.bind(this);

        this.generateTagCategories = this.generateTagCategories.bind(this);
        this.generateTags = this.generateTags.bind(this);
        this.generatePeriodOptions = this.generatePeriodOptions.bind(this);
    }

    componentDidMount() {
        try {
            let userId = JSON.parse(window.localStorage['zzAccount']).userId;
            this.stackService.getUserTagsAndGroups(userId, (userStackupSettings) => {
                if (userStackupSettings.tagItems !== undefined && userStackupSettings.tagItems !== null) {
                    this.tempTagList = userStackupSettings.tagItems;
                    this.tempTagListOld = userStackupSettings.tagItems;
                }

                if (userStackupSettings.groupItems !== undefined && userStackupSettings.groupItems !== null) {
                    this.tempGroupList = userStackupSettings.groupItems;
                    this.tempGroupListOld = userStackupSettings.groupItems;
                }
                this.forceUpdate();
            }, (er) => {
                console.log(er);
            });
        }
        catch (err) {
            console.log(err);
        }
    }

    componentWillReceiveProps() {
        if (this.state.selectedTagCategory === undefined) {
            this.setState({ selectedTagCategory: Object.keys(this.props.screenContext.tagList)[0] })

        }
    }

    componentWillUnmount() {
        if (this.state.periodOpen) {
            this.togglePeriodOpen();
        }
    }

    togglePeriodOpen() {
        this.setState({ periodOpen: !this.state.periodOpen });
    }

    selectPeriod(range) {

        this.props.changePeriod(range);

        this.setState({ periodOpen: false });
    }

    numberWithCommas(number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    getPeriodChart(periodRatio) {
        return (
            <ReactEcharts
                className="stackup-bottom-bar-period-chart"
                height={'100%'}
                option={{
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b}: {c} ({d}%)",
                        show: false
                    },
                    legend: {
                        orient: 'vertical',
                        x: 'left',
                        data: ['Green', 'Grey']
                    },
                    series: [
                        {
                            name: 'Period',
                            type: 'pie',
                            radius: ['50%', '70%'],
                            avoidLabelOverlap: false,
                            label: {
                                normal: {
                                    show: false,
                                    position: 'center'
                                },
                                emphasis: {
                                    show: false,
                                    textStyle: {
                                        fontSize: '30',
                                        fontWeight: 'bold'
                                    }
                                }
                            },
                            labelLine: {
                                normal: {
                                    show: false
                                }
                            },
                            color: ['#29545F', '#d8d8d8'],
                            data: [
                                { value: periodRatio[0], name: '' },
                                { value: periodRatio[1], name: '' }
                            ]
                        }
                    ]
                }}
            />
        );
    }

    expandTagMenu() {
        if (!this.state.tagMenuOpen && this.props.screenContext.mode === 'main') {
            this.setState({ tagMenuOpen: true });
        }
    }

    closeTagMenu() {
        if (this.state.tagMenuOpen) {
            this.tempTagList = this.tempTagListOld.slice(0);
            this.tempGroupList = this.tempGroupListOld.slice(0);
            this.setState({ tagMenuOpen: false });
        }
    }

    clearTagMenu() {
        this.tempTagList = [];
        this.tempGroupList = [];
        this.forceUpdate();
    }

    saveTagMenu() {
        this.tempTagListOld = this.tempTagList.slice(0);
        this.tempGroupListOld = this.tempGroupList.slice(0);
        this.props.saveTags(this.tempTagList, this.tempGroupList);
        this.setState({ tagMenuOpen: false });
    }

    toggleTempTag(tag) {

        if (this.tempTagList.length === 0) {
            this.tempTagList.push(tag);
        } else {

            let match = false;
            for (var i = 0; i < this.tempTagList.length; i++) {
                if (this.tempTagList[i].name === tag.name) {
                    match = true;
                    this.tempTagList.splice(i, 1);
                    break;
                }
            }
            if (!match) {
                this.tempTagList.push(tag);
            }
        }

        this.forceUpdate();
    }

    toggleTempGroup(group) {

        if (this.tempGroupList.length === 0) {
            this.tempGroupList.push(group);
        } else {

            let match = false;
            for (var i = 0; i < this.tempGroupList.length; i++) {
                if (this.tempGroupList[i].groupId === group.groupId) {
                    match = true;
                    this.tempGroupList.splice(i, 1);
                    break;
                }
            }
            if (!match) {
                this.tempGroupList.push(group);
            }
        }

        this.forceUpdate();
    }

    setTagCategory(category) {
        this.setState({ selectedTagCategory: category });
    }

    generateTagCategories() {
        let tagCategoriesJsx = [];

        let categories = Object.keys(this.props.screenContext.tagList);

        for (var i = 0; i < categories.length; i++) {

            let match = false;
            for (var j = 0; j < this.props.screenContext.tagList[categories[i]].length; j++) {
                if (_.contains(this.tempTagList, this.props.screenContext.tagList[categories[i]][j])) {
                    match = true;
                    break;
                }
            }

            if (match === false) {
                for (var t = 0; t < this.tempTagList.length; t++) {
                    for (var j = 0; j < this.props.screenContext.tagList[categories[i]].length; j++) {
                        if (this.tempTagList[t].tagId === this.props.screenContext.tagList[categories[i]][j].tagId) {
                            match = true;
                        }
                    }
                }
            }

            let categoryClass = "category-item";

            if (categories[i] === this.state.selectedTagCategory) {
                categoryClass += ' category-item-selected';
            }

            let iconStyle = {};
            if (match) {
                iconStyle.transform = 'scale(1, 1)';
            }

            tagCategoriesJsx.push((
                <div className={categoryClass} onClick={this.setTagCategory.bind(null, categories[i])}>
                    <div className="category-item-name">
                        {categories[i]}
                    </div>
                    <div className="category-item-icon" style={iconStyle}></div>
                </div>
            ));
        }

        let match = this.tempGroupList.length > 0;

        let categoryClass = "category-item";

        if (this.state.selectedTagCategory === "Groups") {
            categoryClass += ' category-item-selected';
        }

        let iconStyle = {};
        if (match) {
            iconStyle.transform = 'scale(1, 1)';
        }

        tagCategoriesJsx.push((
            <div className={categoryClass} onClick={this.setTagCategory.bind(null, "Groups")}>
                <div className="category-item-name">
                    {"Groups"}
                </div>
                <div className="category-item-icon" style={iconStyle}></div>
            </div>
        ));

        return tagCategoriesJsx;
    }

    generateTags() {
        let tagsJsx = [];

        let categories = Object.keys(this.props.screenContext.tagList);
        for (var i = 0; i < categories.length; i++) {

            let tagsInnerJsx = [];
            for (var j = 0; j < this.props.screenContext.tagList[categories[i]].length; j++) {


                let match = _.contains(this.tempTagList, this.props.screenContext.tagList[categories[i]][j]);
                //let match = _.contains(this.state.userSelectedTags, this.props.screenContext.tagList[categories[i]][j]);

                if (match === false) {
                    for (var t = 0; t < this.tempTagList.length; t++) {
                        if (this.tempTagList[t].tagId === this.props.screenContext.tagList[categories[i]][j].tagId) {
                            match = true;
                        }
                    }
                }


                let pieceStyle = {};
                let rand = (Math.random() * 0.125).toFixed(3);
                if (categories[i] != this.state.selectedTagCategory) {
                    pieceStyle.opacity = '0';
                    pieceStyle.transform = 'scale(0.5, 0.5)';
                    pieceStyle.transition = 'opacity 0.125s ease-in-out ' + rand + 's, transform 0.125s ease-in-out ' + rand + 's, color 0.125s ease-in-out 0s';
                } else {
                    let addRand = (parseFloat(rand) + 0.125);
                    pieceStyle.opacity = '1';
                    pieceStyle.transform = 'scale(1, 1)';
                    pieceStyle.transition = 'opacity 0.125s ease-in-out ' + addRand + 's, transform 0.125s ease-in-out ' + addRand + 's, color 0.125s ease-in-out 0s';
                }
                if (match) {
                    pieceStyle.color = 'rgba(0, 126, 181, 1)';
                }

                tagsInnerJsx.push((
                    <div className="tag-piece" style={pieceStyle} onClick={this.toggleTempTag.bind(null, this.props.screenContext.tagList[categories[i]][j])}>
                        {this.props.screenContext.tagList[categories[i]][j].name}
                    </div>
                ));
            }

            let tagsStyle = {}
            if (categories[i] != this.state.selectedTagCategory) {
                tagsStyle.pointerEvents = 'none';
            }

            tagsJsx.push((
                <div className="tag-inner" style={tagsStyle}>
                    {tagsInnerJsx}
                </div>
            ))
        }

        let tagsInnerJsx = [];
        Object.values(this.props.screenContext.groupList).forEach(group => {
            let match = this.tempGroupList.reduce((r, e) => { if (e.groupId === group.groupId) { r = true; } return r; }, false);

            let pieceStyle = {};
            let rand = (Math.random() * 0.125).toFixed(3);
            if (this.state.selectedTagCategory != "Groups") {
                pieceStyle.opacity = '0';
                pieceStyle.transform = 'scale(0.5, 0.5)';
                pieceStyle.transition = 'opacity 0.125s ease-in-out ' + rand + 's, transform 0.125s ease-in-out ' + rand + 's, color 0.125s ease-in-out 0s';
            } else {
                let addRand = (parseFloat(rand) + 0.125);
                pieceStyle.opacity = '1';
                pieceStyle.transform = 'scale(1, 1)';
                pieceStyle.transition = 'opacity 0.125s ease-in-out ' + addRand + 's, transform 0.125s ease-in-out ' + addRand + 's, color 0.125s ease-in-out 0s';
            }
            if (match) {
                pieceStyle.color = 'rgba(0, 126, 181, 1)';
            }

            tagsInnerJsx.push((
                <div className="tag-piece" style={pieceStyle} onClick={this.toggleTempGroup.bind(null, group)}>
                    {group.name}
                </div>
            ));
        });

        let tagsStyle = {}
        if (this.state.selectedTagCategory != "Groups") {
            tagsStyle.pointerEvents = 'none';
        }

        tagsJsx.push((
            <div className="tag-inner" style={tagsStyle}>
                {tagsInnerJsx}
            </div>
        ))

        return tagsJsx;
    }

    generatePeriodOptions() {
        let periodOptionsClasses = [
            'stackup-bottom-bar-period-drop-item',
            'stackup-bottom-bar-period-drop-item',
            'stackup-bottom-bar-period-drop-item',
            'stackup-bottom-bar-period-drop-item',
            'stackup-bottom-bar-period-drop-item']

        switch (this.props.screenContext.range != undefined ? this.props.screenContext.range : 'CUR') {
            case 'CUR': periodOptionsClasses[0] += ' color-emerald';
                break;
            case 'WTD': periodOptionsClasses[1] += ' color-emerald';
                break;
            case 'MTD': periodOptionsClasses[2] += ' color-emerald';
                break;
            case 'QTD': periodOptionsClasses[3] += ' color-emerald';
                break;
            case 'YTD': periodOptionsClasses[4] += ' color-emerald';
        }

        let optionsJsx = [];
        if (this.props.canSelectPeriod('CUR')) {
            optionsJsx.push((<div className={periodOptionsClasses[0]} onClick={this.selectPeriod.bind(null, 'CUR')}>Selected Date</div>));
        }
        if (this.props.canSelectPeriod('WTD')) {
            optionsJsx.push((<div className={periodOptionsClasses[1]} onClick={this.selectPeriod.bind(null, 'WTD')}>Week to Date</div>));
        }
        if (this.props.canSelectPeriod('MTD')) {
            optionsJsx.push((<div className={periodOptionsClasses[2]} onClick={this.selectPeriod.bind(null, 'MTD')}>Month to Date</div>));
        }
        if (this.props.canSelectPeriod('QTD')) {
            optionsJsx.push((<div className={periodOptionsClasses[3]} onClick={this.selectPeriod.bind(null, 'QTD')}>Quarter to Date</div>));
        }
        if (this.props.canSelectPeriod('YTD')) {
            optionsJsx.push((<div className={periodOptionsClasses[4]} onClick={this.selectPeriod.bind(null, 'YTD')}>Year to Date</div>));
        }

        return optionsJsx;
    }

    render() {

        let range = this.props.screenContext.range;

        let periodRatio = [0, 1];
        let periodIcon = 'Q';

        switch (range != undefined ? range : 'CUR') {
            case 'CUR': periodRatio = [1, 44]; periodIcon = 'D';
                break;
            case 'WTD': periodRatio = [1, 22]; periodIcon = 'W';
                break;
            case 'MTD': periodRatio = [1, 11]; periodIcon = 'M';
                break;
            case 'QTD': periodRatio = [1, 3]; periodIcon = 'Q';
                break;
            case 'YTD': periodRatio = [1, 0]; periodIcon = 'Y';
        }

        let periodOptionsJsx = this.generatePeriodOptions();

        let periodChart = this.getPeriodChart(periodRatio);

        let periodOpenClass = 'stackup-bottom-bar-period-drop-outer';
        if (this.state.periodOpen) {
            periodOpenClass += ' stackup-bottom-bar-period-drop-outer--active';
        }

        let rightSideJsx = null;
        let rightSvgStyle = {};
        let rightTagStyle = {};
        if (this.props.screenContext.mode === 'main' && !this.state.tagMenuOpen) {

            if (this.tempTagList.length > 0 || this.tempGroupList.length > 0) {

                rightSvgStyle.fill = 'rgba(0, 126, 181, 1)';
            }
        } else {
            rightSvgStyle.opacity = '0';
            rightSvgStyle.transform = 'rotateZ(-68deg) translate(0rem, 0rem)';
            rightTagStyle.right = '4.2rem';
            rightTagStyle.opacity = '0';
        }
        rightSideJsx = (
            <div className="stackup-bottom-bar-right-container" onClick={this.expandTagMenu}>
                <svg className="stackup-bottom-bar-tags" style={rightSvgStyle} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 48 48">
                    <path class="st0" d="M44.1,31.9L34.1,8c-0.6-1.5-2.1-2.4-3.6-2.5c-0.5,0-1.1,0.1-1.6,0.3l-14.7,6.1c-1.5,0.6-2.4,2.1-2.5,3.6c0,0.5,0.1,1.1,0.3,1.6L22,41c0.6,1.5,2.1,2.4,3.7,2.5c0.5,0,1-0.1,1.5-0.3l14.7-6.1C43.9,36.3,44.9,33.9,44.1,31.9z M15.8,17.5c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S16.9,17.5,15.8,17.5z" />
                </svg>
                <svg className="stackup-bottom-bar-tags" style={rightSvgStyle} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 48 48">
                    <path class="st0" d="M44.1,31.9L34.1,8c-0.6-1.5-2.1-2.4-3.6-2.5c-0.5,0-1.1,0.1-1.6,0.3l-14.7,6.1c-1.5,0.6-2.4,2.1-2.5,3.6c0,0.5,0.1,1.1,0.3,1.6L22,41c0.6,1.5,2.1,2.4,3.7,2.5c0.5,0,1-0.1,1.5-0.3l14.7-6.1C43.9,36.3,44.9,33.9,44.1,31.9z M15.8,17.5c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S16.9,17.5,15.8,17.5z" />
                </svg>
                <svg className="stackup-bottom-bar-tags" style={rightSvgStyle} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 48 48">
                    <path class="st0" d="M44.1,31.9L34.1,8c-0.6-1.5-2.1-2.4-3.6-2.5c-0.5,0-1.1,0.1-1.6,0.3l-14.7,6.1c-1.5,0.6-2.4,2.1-2.5,3.6c0,0.5,0.1,1.1,0.3,1.6L22,41c0.6,1.5,2.1,2.4,3.7,2.5c0.5,0,1-0.1,1.5-0.3l14.7-6.1C43.9,36.3,44.9,33.9,44.1,31.9z M15.8,17.5c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S16.9,17.5,15.8,17.5z" />
                </svg>
                <svg className="stackup-bottom-bar-tags" style={rightSvgStyle} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 48 48">
                    <path class="st0" d="M44.1,31.9L34.1,8c-0.6-1.5-2.1-2.4-3.6-2.5c-0.5,0-1.1,0.1-1.6,0.3l-14.7,6.1c-1.5,0.6-2.4,2.1-2.5,3.6c0,0.5,0.1,1.1,0.3,1.6L22,41c0.6,1.5,2.1,2.4,3.7,2.5c0.5,0,1-0.1,1.5-0.3l14.7-6.1C43.9,36.3,44.9,33.9,44.1,31.9z M15.8,17.5c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S16.9,17.5,15.8,17.5z" />
                </svg>
                <div className="stackup-bottom-bar-tags-name" style={rightTagStyle}>TAGS</div>
            </div>
        );

        let dateStyle = {}
        if (this.props.screenContext.mode != 'main') {
            dateStyle.opacity = '0';
        }

        let tagMenuJsx = null;
        if (this.props.screenContext.mode === 'main') {

            let tagMenuOuterClass = "tagmenu-outer";
            let clearButtonClass = "tag-button";
            if (this.tempTagList.length === 0 && this.tempGroupList.length === 0) {
                clearButtonClass += " tag-button-disabled";
            }
            if (this.state.tagMenuOpen) {
                tagMenuOuterClass += ' tagmenu-outer-expanded';
            }

            let buttonContainerClass = "button-container";
            if (_.difference(this.tempTagList, this.tempTagListOld).length === 0 && _.difference(this.tempTagListOld, this.tempTagList).length === 0 &&
                _.difference(this.tempGroupList, this.tempGroupListOld).length === 0 && _.difference(this.tempGroupListOld, this.tempGroupList).length === 0) {

            } else {
                buttonContainerClass += ' button-container-color';
            }


            tagMenuJsx = (
                <div className={tagMenuOuterClass}>
                    <div className="tag-background" onClick={this.closeTagMenu}></div>
                    <div className="category-container">
                        {this.generateTagCategories()}
                    </div>
                    <div className="tag-container">
                        {this.generateTags()}
                    </div>
                    <div className={buttonContainerClass}>
                        <div className={clearButtonClass} onClick={this.clearTagMenu}>CLEAR</div>
                        <div className="tag-button" onClick={this.saveTagMenu}>SAVE</div>
                    </div>
                </div>
            );
        }

        let todayDate = new Date();
        todayDate.setHours(12);

        return (
            <div className="stackup-bottom-bar-outer">
                <div className="stackup-bottom-bar-datepicker-container" style={dateStyle}>
                    <DatePicker
                        id="stackup-inline-date-picker-portait"
                        className="stackup-bottom-bar-datepicker"
                        label={null}
                        inline
                        defaultValue={todayDate}
                        displayMode="portrait"
                        fullWidth={false}
                        formatOptions={{
                            year: '2-digit',
                            month: '2-digit',
                            day: '2-digit'
                        }}
                        maxDate={todayDate}
                        minDate={new Date('01/01/2000')}
                        onChange={this.props.changeDate}
                    />
                    <div className="stackup-bottom-bar-date-triangle material-icons">arrow_drop_down</div>
                </div>
                <div className="stackup-bottom-bar-period-container" onClick={this.togglePeriodOpen}>
                    {periodChart}
                    <div className="stackup-bottom-bar-period-icon">{periodIcon}</div>
                </div>
                <div className={periodOpenClass} onClick={this.togglePeriodOpen}>
                    <div className="stackup-bottom-bar-period-drop-container" style={this.state.periodOpen ? { height: periodOptionsJsx.length * 3.14 + 'rem' } : {}}>
                        {periodOptionsJsx}
                    </div>
                </div>
                {rightSideJsx}
                {tagMenuJsx}
            </div>
        );
    }
}
